import * as React from "react";
import { LandingWidgetsConfig } from "../../types";
import Header from "../Header";
import StartChatWidget from "./StartChatWidget";
import KBWidget from "./KBWidget";
import CallWidget from "./CallWidget";
import MessengerFlexContainer from "../MessengerFlexContainer";
import FormWidget from "./FormWidget";
import { useMemo } from "react";
import NetsuiteOrderLookupWidget from "./NetsuiteOrderLookupWidget";

interface Props {
  config: LandingWidgetsConfig;
  onCollapse(): void;
  onStartChat(): void;
}

export default function LandingWidgetContainer(props: Props) {
  const hasFormWidgets = useMemo(() => {
    return props.config.FormWidgets && props.config.FormWidgets.length > 0;
  }, [props.config.FormWidgets]);

  if (!props.config) {
    return null;
  }

  return (
    <MessengerFlexContainer>
      <Header isPopout={false} onCollapse={props.onCollapse} />
      <div className="velaro-landing-widget-container">
        <div className="widget-overflow velaro-scroll">
          {props.config.StartChatWidget && (
            <StartChatWidget
              config={props.config.StartChatWidget}
              onStartChat={props.onStartChat}
            />
          )}
          {props.config.KBWidget && <KBWidget config={props.config.KBWidget} />}
          {props.config.CallWidget && (
            <CallWidget config={props.config.CallWidget} />
          )}
          {props.config.NetsuiteOrderLookupWidget && (
            <NetsuiteOrderLookupWidget
              config={props.config.NetsuiteOrderLookupWidget}
            />
          )}
          {hasFormWidgets &&
            props.config.FormWidgets.map((widget, i) => (
              <FormWidget key={i} config={widget} index={i} />
            ))}
        </div>
      </div>
    </MessengerFlexContainer>
  );
}
